/* istanbul ignore file */
export { DateFormat, default as FormattedDate } from './formattedDate'
